import React from "react";
import "../pages/Home.css";

// Import Logos
import appleLogo from "../assets/apple1.svg";
import googleLogo from "../assets/google-pixel-1.svg";
import motorolaLogo from "../assets/motorola.svg";
import oneplusLogo from "../assets/oneplus-2.svg";
import oppoLogo from "../assets/oppo.svg";
import realmeLogo from "../assets/realme-logo (1).svg";
import vivoLogo from "../assets/vivo.svg";
import xiaomiLogo from "../assets/xiaomi-1.svg";

const brands = [
  {
    id: 1,
    name: "Apple",
    logo: appleLogo,
    bg: "rgba(148, 163, 184, 0.18)",
    border: "rgba(100, 116, 139, 0.35)",
    accent: "#64748b",
    glow: "rgba(100, 116, 139, 0.25)",
  },
  {
    id: 2,
    name: "Google Pixel",
    logo: googleLogo,
    bg: "rgba(52, 168, 83, 0.16)",
    border: "rgba(52, 168, 83, 0.35)",
    accent: "#34a853",
    glow: "rgba(52, 168, 83, 0.26)",
  },
  {
    id: 3,
    name: "Motorola",
    logo: motorolaLogo,
    bg: "rgba(37, 99, 235, 0.15)",
    border: "rgba(37, 99, 235, 0.34)",
    accent: "#2563eb",
    glow: "rgba(37, 99, 235, 0.25)",
  },
  {
    id: 4,
    name: "OnePlus",
    logo: oneplusLogo,
    bg: "rgba(239, 68, 68, 0.15)",
    border: "rgba(239, 68, 68, 0.36)",
    accent: "#ef4444",
    glow: "rgba(239, 68, 68, 0.24)",
  },
  {
    id: 5,
    name: "Oppo",
    logo: oppoLogo,
    bg: "rgba(22, 163, 74, 0.16)",
    border: "rgba(22, 163, 74, 0.35)",
    accent: "#16a34a",
    glow: "rgba(22, 163, 74, 0.24)",
  },
  {
    id: 6,
    name: "Realme",
    logo: realmeLogo,
    bg: "rgba(234, 179, 8, 0.18)",
    border: "rgba(202, 138, 4, 0.36)",
    accent: "#ca8a04",
    glow: "rgba(202, 138, 4, 0.25)",
  },
  {
    id: 7,
    name: "Vivo",
    logo: vivoLogo,
    bg: "rgba(14, 165, 233, 0.16)",
    border: "rgba(14, 165, 233, 0.34)",
    accent: "#0ea5e9",
    glow: "rgba(14, 165, 233, 0.24)",
  },
  {
    id: 8,
    name: "Xiaomi",
    logo: xiaomiLogo,
    bg: "rgba(249, 115, 22, 0.17)",
    border: "rgba(249, 115, 22, 0.36)",
    accent: "#f97316",
    glow: "rgba(249, 115, 22, 0.24)",
  },
];

const BrandSlider = () => {
  const repeatedBrands = [...brands, ...brands, ...brands];

  return (
    <div className="brand-section-wrapper">

      {/* HEADER */}
      <div className="brand-header">
        <span
          style={{
            color: "#2563eb",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "15px",
            fontWeight: "600",
            display: "inline-block"
          }}
        >
          TRUSTED EXPERTISE
        </span>

        {/* ✅ SEO HEADING */}
        <h2>
          Mobile Repair Services for{" "}
          <span className="gradient-text">All Major Brands</span>
        </h2>

        {/* ✅ SEO DESCRIPTION */}
        <p className="brand-desc">
          We repair Apple, Samsung, OnePlus, Vivo, Oppo, Realme, Xiaomi and all major mobile brands with expert technicians.
        </p>
      </div>

      {/* SLIDER */}
      <div className="marquee-container">
        <div className="marquee-content" style={{ "--brand-count": brands.length }}>
          {repeatedBrands.map((brand, index) => (
            <div
              className="brand-card"
              key={`${brand.id}-${index}`}
              style={{
                "--brand-bg": brand.bg,
                "--brand-border": brand.border,
                "--brand-accent": brand.accent,
                "--brand-glow": brand.glow,
              }}
            >
              {/* ✅ ALT SEO */}
              <img src={brand.logo} alt={`${brand.name} mobile repair service`} />
            </div>
          ))}
        </div>

        <div className="overlay-left"></div>
        <div className="overlay-right"></div>
      </div>

      {/* ✅ HIDDEN SEO */}
      <div style={{ display: "none" }}>
        apple mobile repair, samsung mobile repair, oneplus repair,
        vivo repair, oppo repair, realme repair, xiaomi repair near me
      </div>

    </div>
  );
};

export default BrandSlider;